import React from 'react'
import PropTypes from 'prop-types'

const TriggerTitle = ({ children }) => {
  return <span className="trigger-title">{children}</span>
}

TriggerTitle.propTypes = {
  children: PropTypes.node,
}

export default TriggerTitle
